import { render, staticRenderFns } from "./group.vue?vue&type=template&id=37f3f110&scoped=true"
import script from "./group.vue?vue&type=script&lang=js"
export * from "./group.vue?vue&type=script&lang=js"
import style0 from "./group.vue?vue&type=style&index=0&id=37f3f110&lang=scss&scoped=true"
import style1 from "./group.vue?vue&type=style&index=1&id=37f3f110&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f3f110",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37f3f110')) {
      api.createRecord('37f3f110', component.options)
    } else {
      api.reload('37f3f110', component.options)
    }
    module.hot.accept("./group.vue?vue&type=template&id=37f3f110&scoped=true", function () {
      api.rerender('37f3f110', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/advancecomponets/group.vue"
export default component.exports